import { ConsentMonitor } from './utils/ConsentMonitor'
import { Promise } from 'es6-promise'

class Page {
  constructor(pagePostMessager) {
    this._pagePostMessager = pagePostMessager
    this._counter = 0

    this.datafields = {
      get: (sessionDataFieldName) => {
        return new Promise((resolve, reject) => {
          const requestId = `${sessionDataFieldName}_${this._getCounter()}`
          const onResponse = (data) => {
            this._pagePostMessager.off(requestId, onResponse)
            if (!data || data.error) reject(data.error)
            resolve(data.value)
          }

          this._pagePostMessager.on(requestId, onResponse)
          this._pagePostMessager.send('get_data', {
            requestId,
            sessionDataFieldName,
          })
        })
      },

      set: (sessionDataFieldName, value) => {
        this._pagePostMessager.send('set_data', {
          sessionDataFieldName,
          value,
        })
      },
    }

    this.actions = {
      run: (actionName) => {
        this._pagePostMessager.send('run_action', {
          actionName,
        })
      },
    }

    this.events = {
      subscribe: (event, cb) => {
        this._pagePostMessager.on('dot_embed_event', (data) => {
          if (data.event && data.event === event) cb(data.data)
        })
      },

      unsubscribe: (event, cb) => {},
    }

    this.consents = {
      /**
       *
       * @param {string} entity e.g. OneTrust
       * @param {Array<string>} consents
       */
      set: (entity, consents) => {
        this.setConsents(entity, consents)
      },
    }

    this.consentMonitor = new ConsentMonitor({
      onChange: ({ entity, consents }) => {
        this.consents.set(entity, consents)
      },
    })
  }

  destroy() {
    if (this.consentMonitor) this.consentMonitor.destroy()
  }

  setConsents(entity, consents) {
    setTimeout(
      () =>
        this._pagePostMessager.send('dot_embed_consents:entity:set', {
          entity,
          consents,
        }),
      1000
    )
  }

  _getCounter() {
    return ++this._counter
  }
}

export { Page }
